export const getCountry = (payment) => {
  return payment.data.dataOperation.CurrencyCode
}